__turbopack_context__.v({
  "breadcrumb": "_0WJZaq_breadcrumb",
  "current": "_0WJZaq_current",
  "link": "_0WJZaq_link",
  "root": "_0WJZaq_root",
  "separator": "_0WJZaq_separator",
});
